import { CBC_REPORT_TYPES } from '@core/classes/Enums';
import api from '@core/services/api/_api';

export default class FIMenuCreditReport {
	// flags: CreditReportFlag | null;
	// id: string | null;
	// reports: CreditReportReports | null;

	constructor(init) {
		if (init) {
			this.flags = init.flags?.map(v => new CreditReportFlags(v)) ?? [];
			this.id = init.id;
			this.reports = init.reports?.map(v => new CreditReportReportType(v)) ?? [];
			this.createdAt = init.createdAt;
			this.lastCreditPull = init.lastCreditPull;
			this.selectedPulls = init.selectedPulls?.map(v => new SelectedPulls(v)) ?? [];
		} else {
			this.flags = [];
			this.id = null;
			this.reports = [];
			this.createdAt = null;
			this.lastCreditPull = null;
			this.selectedPulls = [];
		}

		this.OFAC = {
			report: () => this.getReportByType(CBC_REPORT_TYPES.OFAC),
			flags: () => this.getFlagsByType(0), // MAKE ENUM FOR REDFLAG TYPES.,
			isOfacNoHit: () => {
				const ofacReport = this.OFAC.report();
				const hasId = ofacReport?.physicalReportId != null && ofacReport?.physicalReportId != '';

				return hasId && !ofacReport.error.hasError;
			},
		};
	}

	isOfacNA() {
		if (this.OFAC.flags() == null) return true;

		return this.OFAC.flags()?.redflags.length == 0 && this.OFAC.report()?.error.message == 'N/A';
	}
	getReportFromType(reqReportType) {
		if (reqReportType == null) return null;

		let reportType = reqReportType;

		if (typeof reportType == 'string') {
			reportType = CBC_REPORT_TYPES.reportTypeStringToEnum(reqReportType);
		}

		return this.reports.find(report => report.type == reportType);
	}

	async saveFlags(customerId) {
		return await api.creditreport.updateRedFlags(this, customerId);
	}

	flagsCount() {
		let counter = 0;

		const totalCount = this.flags.reduce((accumulator, value) => {
			if (value.isValidated() == false) accumulator++;
			return accumulator;
		}, counter);

		return totalCount;
	}

	experian() {
		return this.getReportByType(CBC_REPORT_TYPES.XPN);
	}

	equifax() {
		return this.getReportByType(CBC_REPORT_TYPES.EFX);
	}

	transUnion() {
		return this.getReportByType(CBC_REPORT_TYPES.TU);
	}

	OFACReport() {
		return this.getReportByType(CBC_REPORT_TYPES.OFAC);
	}
	MLAReport() {
		return this.getReportByType(CBC_REPORT_TYPES.MLA);
	}

	getReportByType(type) {
		return this.reports.find(x => x.type == type);
	}

	getFlagsByType(type) {
		return this.flags.find(x => x.type == type);
	}

	/**
	 * @param {object} customer
	 * @returns boolean true if any of the customer's personal info is null
	 */
	customerIsUnableToPullCreditReport(customer) {
		let customerData = [
			customer.firstName,
			customer.lastName,
			customer.address,
			customer.city,
			customer.state,
			customer.zip,
			customer.county,
			customer.email,
			customer.cell,
			customer.dob,
		];
		return customerData.some(value => value === null);
	}

	/**
	 * @param {enum / int} reportType
	 * @returns Boolean True if the given report type is NOT Ofac or MLA.
	 */
	isABureau(reportType) {
		return CBC_REPORT_TYPES.reportTypeEnumToString(reportType) !== 'OFAC' && CBC_REPORT_TYPES.reportTypeEnumToString(reportType) !== 'MLA';
	}
}

class CreditReportFlags {
	/*     redflags : [] | null
    success: boolean | null;
    type: number | null // enum */

	constructor(init) {
		if (init) {
			this.redflags = init.redflags.map(redFlag => new RedFlag(redFlag));
			this.type = init.type;
		} else {
			this.redflags = null;
			this.type = null;
		}
	}

	//change to hasMissingComment
	isValidated() {
		return !this.redflags.some(flag => !flag.comment);
	}
}

class RedFlag {
	constructor(init) {
		if (init) {
			this.comment = init.comment;
			this.commentDate = init.commentDate;
			this.flagDate = init.flagDate;
			this.id = init.id;
			this.reason = init.reason;
			this.reviewedBy = init.reviewedBY;
			this.commentAlreadyExists = this.commentAlreadyExists(this.comment);
			//if there is comment, then make it true. if the new value is not an empty string, then its valid. if it is an empty string. its invalid.
		} else {
			this.comment = null;
			this.commentDate = null;
			this.flagDate = null;
			this.id = null;
			this.reason = null;
			this.reviewedBy = null;
		}
	}

	commentAlreadyExists(comment) {
		return comment ? true : false;
	}
}

class CreditReportReportType {
	/*  physicalReport: string | null
    physicalReportId: string | null
    score: string | null
    type: number | null */

	constructor(init) {
		if (init) {
			this.physicalReport = init.physicalReport;
			this.physicalReportId = init.physicalReportId;
			this.score = init.score;
			this.type = init.type;
			this.reportDate = init.reportDate;
			this.error = new BureauError(init.error);
			this.reportMessages = init.reportMessages;
		} else {
			this.physicalReport = null;
			this.physicalReportId = null;
			this.score = null;
			this.type = null;
			this.reportDate = null;
			this.error = new BureauError();
			this.reportMessages = null;
		}
	}
}

class BureauError {
	constructor(init) {
		if (init) {
			this.message = init.message;
			this.hasError = init.hasError;
			this.code = init.code;
		} else {
			this.message = null;
			this.hasError = null;
			this.code = null;
		}
	}
}

/*
    physicalReportId: string | null
    bureauType: string | null
*/
class SelectedPulls {
	constructor(init) {
		if (init) {
			this.physicalReportId = init.physicalReportId;
			this.bureauType = init.bureauType;
			this.dateSelected = init.dateSelected;
		} else {
			this.physicalReportId = null;
			this.bureauType = null;
			this.dateSelected = null;
		}
	}
}
